<template>
    <div class="products-page">
        <breadcrumbs class="pb-3" />
        <contracts :show-link="false" :limit="15" />
    </div>
</template>

<script lang="ts">
    import {Vue, Component} from 'vue-facing-decorator'
    import Contracts from '~src/components/supplier/Contracts.vue'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'

    @Component({
        components: {
            Contracts,
            Breadcrumbs,
        },
    })
    export class ProductsPage extends Vue {
        get isTO1() {
            return authStore.isTO1
        }
    }

    export default ProductsPage
</script>
